import React, { useRef, useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Grid, Box } from '@mui/material'
import { MuiSelectAutoComplete, MuiTextField, MuiButton, MuiCheckbox, LoaderDots } from '../../../../../components'
import keywordManagement from '../../../../../services/keywordManagement.service'
import { useGlobalStore } from '../../../../../store'
import { consoleLog, getObjectAsArray, getDistinctValues, sortByKey } from '../../../../../util'
import { OuterWrapper, Error, Message, CheckboxWrapper, Title } from './style'

const Add = ({ onChange }) => {
  const { company } = useGlobalStore()
  const initialFormObj = {
    keywordSelect: '',
    notesSelect: '',
    typeSelect: '',
    keywordInput: '',
    notesInput: '',
    typeInput: ''
  }

  const form = useRef()
  // const [formSectionData, setFormSectionData] = useState(defaultDataFunc())
  const [loader, setLoader] = useState(false)
  const [formData, setFormData] = useState(initialFormObj)
  const [formError, setFormError] = useState('')
  const [formSuccess, setFormSuccess] = useState('')
  const [formSelectData, setFormSelectData] = useState({
    keyword: [],
    notes: [],
    type: []
  })

  const onChangeHandler = (key, value) => {
    const obj = {
      ...formData,
      [key]: value || null
    }
    if (key === 'keywordSelect') {
      obj.keywordInput = null
    } else if (key === 'notesSelect') {
      obj.notesInput = null
    } else if (key === 'typeSelect') {
      obj.typeInput = null
    } else if (key === 'subTypeSelect') {
      obj.subTypeInput = null
    } setFormData(obj)
  }

  const submitPayload = async (e) => {
    e.preventDefault()
    const obj = {
      keywordArray: formSelectData.keyword.filter(i => i.checked)?.map(i => i.label) || [],
      keywordSelect: formData?.keywordSelect?.trim() || null,
      notesSelect: formData?.notesSelect?.trim() || null,
      notesArray: formSelectData.notes.filter(i => i.checked)?.map(i => i.label) || [],
      typeSelect: formData?.typeSelect?.trim() || null,
      typeArray: formSelectData.type.filter(i => i.checked)?.map(i => i.label) || [],
      keywordInput: formData?.keywordInput?.trim() || null,
      notesInput: formData?.notesInput?.trim() || null,
      typeInput: formData?.typeInput?.trim() || null
    }

    const subKeywordLevel1Values = [...obj.notesArray, obj.notesInput].filter(f => f !== '').map(d => ({ string: d }))
    const subKeywordLevel2Values = [...obj.typeArray, obj.typeInput].filter(f => f !== '').map(d => ({ string: d }))
    const parentKeywordValues = obj.keywordArray.filter(f => f !== '').map(d => ({ string: d }))

    const payload_level1 = {
      organizationId: company?.OrganizationId,
      // keywordValues: obj.keywordArray.filter(f => f !== '').map(d => ({ string: d })),
      parentKeywordValues: parentKeywordValues,
      subKeywordLevel1Values: subKeywordLevel1Values,
      subKeywordLevel2Values: [],
      delete: false
    }
    const payload_level2 = {
      ...payload_level1,
      subKeywordLevel2Values: subKeywordLevel2Values
    }

    if (parentKeywordValues.length === 0) {
      setFormError('Kindly select Keywords !!')
      return false
    } else if (subKeywordLevel1Values.length === 0 && subKeywordLevel2Values.length > 0) {
      setFormError('Kindly select Level 1 !!')
      return false
    } else if (subKeywordLevel1Values.length === 0 && subKeywordLevel2Values.length === 0) {
      setFormError('Kindly select Level 1 !!')
      return false
    }

    setLoader(true)
    if (subKeywordLevel1Values.length > 0 && subKeywordLevel2Values.length > 0) {
      await keywordManagement.setOrganizationAggregationSubKeywordsApi(payload_level1)
      await keywordManagement.setOrganizationAggregationSubKeywordsApi(payload_level2)
    } else if (subKeywordLevel1Values.length > 0 && subKeywordLevel2Values.length === 0) {
      await keywordManagement.setOrganizationAggregationSubKeywordsApi(payload_level1)
    }
    setLoader(false)
    setFormSuccess('Data added successfully')
    onChange(obj)
    setTimeout(() => {
      resetForm()
    }, 2000)
  }

  const onload = async () => {
    try {
      const payload = { organizationId: company?.OrganizationId }
      const keywordApi = await keywordManagement.getOrganizationAggregationKeywordsApi(payload)
      const keywordArray = getObjectAsArray(keywordApi, 'adv').map(d => ({ label: d.KeywordValue, value: d.KeywordValue, valKeywordValue: d.KeywordValue, valKeywordId: d.KeywordId, valKeywordSearchTerm: d.KeywordSearchTerm, checked: false }))
      // keywordArray.push({ label: ' ', value: ' ', valKeywordValue: ' ', valKeywordId: ' ', valKeywordSearchTerm: ' ', checked: false })

      const subKeywordApi = await keywordManagement.getOrganizationAggregationSubKeywordDetailsApi(payload)

      const subkeywordLevel1List = getObjectAsArray(subKeywordApi, 'adv').filter(f => f.SubKeywordLevel1Value !== '').map(d => d.SubKeywordLevel1Value)
      const subkeywordLevel1Array = getDistinctValues(subkeywordLevel1List).map(d => ({ label: d, value: d, checked: false }))

      const subkeywordLevel2List = getObjectAsArray(subKeywordApi, 'adv').filter(f => f.SubKeywordLevel2Value !== '').map(d => d.SubKeywordLevel2Value)
      const subkeywordLevel2Array = getDistinctValues(subkeywordLevel2List).map(d => ({ label: d, value: d, checked: false }))

      setFormSelectData(prev => ({ ...prev, keyword: keywordArray, notes: sortByKey(subkeywordLevel1Array, 'label'), type: sortByKey(subkeywordLevel2Array, 'label') }))
    } catch (error) {
      consoleLog('error = ', error)
    }
  }

  const resetForm = () => {
    setFormData(initialFormObj)
    // setFormError('')
    // setFormSuccess('')
    onload()
  }

  useEffect(() => {
    if (company?.OrganizationId) onload()
  }, [company?.OrganizationId])

  // /////////////////////////////////////////////////////////////////////////////////////////////////
  // /////////////////////////////////////////////////////////////////////////////////////////////////

  const [manageSubKeywordsCounts, setManageSubKeywordsCounts] = useState([0, 0])

  const onChangeHandler2 = (e, key, index) => {
    const array = formSelectData[key]
    array[index].checked = e.target.checked
    const finalArray = { ...formSelectData, [key]: array }
    setFormSelectData(finalArray)
  }

  useEffect(() => {
    const checkedData = {
      keyword: formSelectData.keyword.filter((v) => v?.checked),
      notes: formSelectData.notes.filter((v) => v?.checked),
      type: formSelectData.type.filter((v) => v?.checked)
    }
    setManageSubKeywordsCounts([checkedData.keyword.length, checkedData.notes.length, checkedData.type.length])

    onChange(checkedData)
  }, [formSelectData])

  // /////////////////////////////////////////////////////////////////////////////////////////////////
  // /////////////////////////////////////////////////////////////////////////////////////////////////

  return (
    <OuterWrapper>
      <form ref={form} onSubmit={submitPayload} autoComplete='on'>
        <Grid container spacing={2}>
          <Grid item xs={4}>
            <Title>Keyword {manageSubKeywordsCounts[0] > 0 && <span>(Selected: {manageSubKeywordsCounts[0]})</span>}</Title>
            <CheckboxWrapper>
              {formSelectData.keyword.length > 0 && formSelectData.keyword.map((list, i) => {
                return (
                  <MuiCheckbox key={'keyword__' + i} label={list.label} value={list.value} checked={list?.checked} onChange={(e) => onChangeHandler2(e, 'keyword', i)} />
                )
              })}
            </CheckboxWrapper>
          </Grid>
          <Grid item xs={4}>
            <Title>Sub Keyword Level 1 {manageSubKeywordsCounts[1] > 0 && <span>(Selected: {manageSubKeywordsCounts[1]})</span>}</Title>
            <CheckboxWrapper>
              {formSelectData.notes.length > 0 && formSelectData.notes.map((list, i) => {
                return (
                  <MuiCheckbox key={'notes__' + i} label={list.label} value={list.value} checked={list?.checked} onChange={(e) => onChangeHandler2(e, 'notes', i)} />
                )
              })}
            </CheckboxWrapper>
          </Grid>
          <Grid item xs={4}>
            <Title>Sub Keyword Level 2 {manageSubKeywordsCounts[2] > 0 && <span>(Selected: {manageSubKeywordsCounts[2]})</span>}</Title>
            <CheckboxWrapper>
              {formSelectData.type.length > 0 && formSelectData.type.map((list, i) => {
                return (
                  <MuiCheckbox key={'type__' + i} label={list.label} value={list.value} checked={list?.checked} onChange={(e) => onChangeHandler2(e, 'type', i)} />
                )
              })}
            </CheckboxWrapper>
          </Grid>

          <Grid item xs={4} style={{ display: 'none' }}>
            <MuiSelectAutoComplete
              data={formSelectData.keyword}
              name='keyword'
              placeholder='Keyword'
              onChange={(e) => onChangeHandler('keywordSelect', e.target.value)}
              variant='standard'
              disabled={true}
              value={formData.keywordSelect}
            />
          </Grid>
          <Grid item xs={4} style={{ display: 'none' }}>
            <MuiSelectAutoComplete
              data={formSelectData.notes}
              name='notes'
              placeholder='Notes'
              onChange={(e) => onChangeHandler('notesSelect', e.target.value)}
              variant='standard'
              disabled={true}
              value={formData.notesSelect || ''}
            />
          </Grid>
          <Grid item xs={4} style={{ display: 'none' }}>
            <MuiSelectAutoComplete
              data={formSelectData.type}
              name='type'
              placeholder='Type'
              onChange={(e) => onChangeHandler('typeSelect', e.target.value)}
              variant='standard'
              disabled={true}
              value={formData.typeSelect || ''}
            />
          </Grid>
          <Grid item xs={12}></Grid>
          <Grid item xs={4}>
            <MuiTextField
              name='keyword'
              placeholder='Enter Keyword'
              onChange={(e) => onChangeHandler('keywordInput', e.target.value)}
              variant='standard'
              value={formData?.keywordInput || ''}
              style={{ display: 'none' }}
            />
          </Grid>
          <Grid item xs={4}>
            <MuiTextField
              name='notes'
              placeholder='Enter Sub Keyword Level 1'
              onChange={(e) => onChangeHandler('notesInput', e.target.value)}
              variant='standard'
              value={formData?.notesInput || ''}
            />
          </Grid>
          <Grid item xs={4}>
            <MuiTextField
              name='type'
              placeholder='Enter Sub Keyword Level 2'
              onChange={(e) => onChangeHandler('typeInput', e.target.value)}
              variant='standard'
              value={formData?.typeInput || ''}
            />
          </Grid>
          <Grid item xs={13} style={{ justifyContent: 'space-between', display: 'flex' }}>
            <Box>
              {formError && <Error>{formError}</Error>}
              {formSuccess && <Message>{formSuccess}</Message>}
              {loader && <LoaderDots />}
            </Box>
            <Box>
              <MuiButton
                onClick={submitPayload}
                type='submit'
                color='primary'
                variant='contained'
                style={{ width: '120px', marginRight: '10px' }}
                disabled={loader}
              >
                Add
              </MuiButton>
              <MuiButton
                onClick={() => onChange()}
                type='button'
                color='primary'
                variant='contained'
                style={{ width: '120px' }}
              >
                Refresh
              </MuiButton>
            </Box>
          </Grid>
        </Grid>
      </form>
    </OuterWrapper>
  )
}

Add.propTypes = {
  onChange: PropTypes.func
}

export default Add
